import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`


/*********************************************** Main Body Styling**********************************************************/
  body {
    margin: 0;
    padding: 0;
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    font-size:1rem;
    font-family: Open-Sans, Helvetica, Sans-Serif;
    transition: all 0.25s linear;

  }

  .header-container{
    display:flex;
    justify-content:space-between;
    margin:0rem !important;
  }

  .dashboard-header-container{
    display:flex;
    justify-content:center;
    position: relative;
  }

  .header-text-container{
    text-align:center;
  }

  .username-banner{
    position:absolute;
    right:0;
    padding:inherit;
  }
  
  .peer-review-container{
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    align-items:center;
  }
  
/********************************************************************************************************************************/

/***************************************Override mantine styling ************************************************************/
.mantine-Text-root {
  color: inherit;
}


/********************************************************************************************************************************/












/*****************************************************Evidence/Attachment upload box in internal tickets**********************************************************/

.upload-evidence-box{
  min-height:0.5rem !important;
}

.upload-evidence-box-header{
  display:flex;
  flex-direction:column;
  align-items:center;
}

.upload-attachment-box{
  min-height:0.5rem !important;
}

.upload-attachment-box-header{
  display:flex;
  flex-direction:column;
  align-items:center;
}

/*****************************************************************************************************************************************************************/











/*****************************************************Styling for sidebar**********************************************************/
.ui.vertical.menu.customer-sidebar{
  background-color: ${({ theme }) => theme.customerSidebarBackground};
  display:flex;
  justify-content:space-between;
  height:100%;
}

.ui.vertical.menu.admin-sidebar{
  display:flex;
  justify-content:space-between;
  height:100%;
}

.menu.bottom-logout-button{
  margin-top:auto !important;
  padding:3rem;
}

.dashboard-logo-container{
  background-color:${({ theme }) => theme.dashboardLogoContainer}!important;
}
/*************************************************************************************************************************************/













/*****************************************************Styling for Calendar**********************************************************/
.fc-theme-standard .fc-list-day-cushion{
  background-color: ${({ theme }) => theme.fcListDayTheme};

}

.fc-list-day-text, .fc-list-day-side-text{
  color: ${({ theme }) => theme.fcListDayTextTheme};
}

.meta-calendar-checkboxes{
  padding-bottom:inherit !important;
}
/*************************************************************************************************************************************/

input[type="date"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    width: auto;
}







/*****************************************************Semantic UI & any additional library styling**********************************************************/
.ui.cards{
    display:flex;
    margin-right:10px;
    flex-wrap:wrap;
    margin:2rem;
}

.form-field{
  padding-left:0.5rem;
  padding-right:0.5rem;
  padding-top:0.5rem;
}

.ui.selection.active.dropdown {
  z-index:200;
}

i.inverted.bordered.grey.icon, i.inverted.circular.grey.icon{
  margin-left: 0.5rem;
}

.ui.menu{
  z-index: 250 !important;
}

.react-markdown-notes-cells, .react-markdown-notes-headers{
  border: 1px solid black;
}

.react-markdown-notes-table{
  border: 1px solid black;
  border-collapse: collapse;
}

.ui.card.card-body{
  font-size:14px;
  color:${({ theme }) => theme.uiCardBodyTextColor};
  background-color:${({ theme }) => theme.uiCardBodyBackground};
  border-left: 5px solid ${({ theme }) => theme.uiCardLeftBorder};
  margin:2rem;
}
.ui.fluid.card{
  color:${({ theme }) => theme.uiCardBodyTextColor};
  background-color:${({ theme }) => theme.uiCardBodyBackground};
  box-shadow:none;
}

.ui.card>.content>.header, .ui.cards>.card>.content>.header, .ui.card>.content>.description, .ui.cards>.card>.content>.description{
  color:${({ theme }) => theme.uiCardBodyTextColor};
}
.ui.cards a.card:hover{
  background-color:${({ theme }) => theme.uiHoverColorBackground};
}

.ui.header .content, .ui.header, .ui.header .sub.header{
  color:${({ theme }) => theme.uiHeaderTextColor};
}
.ui.segment{
  color:${({ theme }) => theme.uiCardBodyTextColor};
  background-color:${({ theme }) => theme.uiCardBodyBackground};
}
.ui.tabular.menu .item{
  color:${({ theme }) => theme.uiTabTextColor};
  background:${({ theme }) => theme.uiTabBackgroundColor};
  border-left: ${({ theme }) => theme.uiTabBorderColor};
  border-top: ${({ theme }) => theme.uiTabBorderColor};
  border-right: ${({ theme }) => theme.uiTabBorderColor};

}
.ui.tabular.menu .item:hover{
  background:${({ theme }) => theme.uiTabHoverColor};
}
.ui.tab.active, .ui.tab.open{
  background:${({ theme }) => theme.uiTabBackgroundColor};
}
.ui.tabular.menu .active.item{
  background:${({ theme }) => theme.uiTabActiveColor};
  border-color:${({ theme }) => theme.uiTabActiveBorderColor};
  color:${({ theme }) => theme.uiTabTextColor};

}
.ui.attached.segment{
  border:${({ theme }) => theme.uiTabShadowBorder};
}

.ui.attached.tabular.menu{
  border-bottom: ${({ theme }) => theme.uiTabBorderColor};

}
.ui.tabular.menu{
  border:${({ theme }) => theme.uiTabMenuShadowBorder};
  border-bottom:${({ theme }) => theme.uiTabShadowBorder};
}


.ui.definition.table, .ui.table{
  color:${({ theme }) => theme.uiTableTextColor};
  background:${({ theme }) => theme.uiTableBackground};
}
.ui.table thead tr:first-child>th:only-child, .ui.table thead th{
  background:${({ theme }) => theme.uiTableSectionBackground};
}
.ui.definition.table tr td.definition, .ui.definition.table tr td:first-child:not(.ignored), .ui.table thead tr:first-child>th:only-child, .ui.table thead th {  
  color:${({ theme }) => theme.uiTableTextColor};
  border:${({ theme }) => theme.uiTableBorderColor};
}

.ui.definition.table td:nth-child(2), .ui.table tr:first-child td{
  border-top:${({ theme }) => theme.uiTableBorderColor};
  border-right:${({ theme }) => theme.uiTableBorderColor};
  border-bottom:${({ theme }) => theme.uiTableBorderColor};

}

.group-provisions-monthly-report-section{
  overflow-x:overlay !important;
}

.ui.segment.segment-card-styling, .ui.fluid.card.fluid-card-white-styling, .ui.raised.very.padded.text.segment.ticket-form-styling{
  color:${({ theme }) => theme.uiCardBodyTextColor};
  background-color:${({ theme }) => theme.uiCardBodyBackground};
  box-shadow:none;
}
.ui.cards>.card{
  color:${({ theme }) => theme.uiCardBodyTextColor};
  background-color:${({ theme }) => theme.uiCardBodyBackground};
}
.report-services-label{
  color:${({ theme }) => theme.uiCardBodyTextColor};
}
.ui.toggle.checkbox label:before{
  background:#dedede !important;
}
.ui.fluid.card.calendar-body{
  color:${({ theme }) => theme.uiCalendarText};
  background-color:${({ theme }) => theme.uiCalendarBackground};
}
.ui.modal.modal-styling{
  color:black;
}
.ui.very.padded.segment.header-container, .ui.very.padded.segment.dashboard-header-container{
  background:${({ theme }) => theme.uiHeaderBackground};
}



.ui.fluid.input>input,.ui.input>input, .ui.form textarea, .ui.form .field>.selection.dropdown, .ui.form select, .ui.placeholder.segment, .ui.icon.input>input, .ui.icon.input>i.icon:not(.link), .ui.fluid.dropdown, .ui.form input:not([type]), .ui.form input[type=date], .ui.form input[type=datetime-local], .ui.form input[type=email], .ui.form input[type=file], .ui.form input[type=number], .ui.form input[type=password], .ui.form input[type=search], .ui.form input[type=tel], .ui.form input[type=text], .ui.form input[type=time], .ui.form input[type=url], .ui.form input:not([type]):focus, .ui.form input[type=date]:focus, .ui.form input[type=datetime-local]:focus, .ui.form input[type=email]:focus, .ui.form input[type=file]:focus, .ui.form input[type=number]:focus, .ui.form input[type=password]:focus, .ui.form input[type=search]:focus, .ui.form input[type=tel]:focus, .ui.form input[type=text]:focus, .ui.form input[type=time]:focus, .ui.form input[type=url]:focus{
  color:${({ theme }) => theme.uiFormFieldTextColor};
  background-color:${({ theme }) => theme.uiFormFieldBackground};
}

.ui.modal>.content, .ui.modal>.header, .ui.active.modal{
  color:${({ theme }) => theme.uiCardBodyTextColor};
  background-color:${({ theme }) => theme.uiCardBodyBackground};
}

.ui.form .field>label,.ui.toggle.checkbox label, .ui.toggle.checkbox input:checked~.box, .ui.toggle.checkbox input:checked~label, .ui.checkbox label, .ui.form .grouped.fields>label, .ui.checkbox+label, .ui.search.dropdown.active>input.search, .ui.search.dropdown.visible>input.search{
  color:${({ theme }) => theme.uiFormFieldTextColor};

}
.ui.fluid.accordion, .ui.fluid.accordion .accordion, .ui.accordion .accordion .title .dropdown.icon, .ui.accordion .title .dropdown.icon  {
  color:${({ theme }) => theme.uiAccordianTextColor};
  background:${({ theme }) => theme.uiAccordianBackground};
}
.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{
  background:${({ theme }) => theme.ckeditorToolbarBackgroundColor};
}
.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused), .ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{
  background:${({ theme }) => theme.ckEditorBackgroundColor};
  color:${({ theme }) => theme.ckEditorTextColor};

}
.tox .tox-toolbar, .tox .tox-toolbar__overflow, .tox .tox-toolbar__primary{
  background-color:${({ theme }) => theme.tinyMCEToolbarBackgroundColor};
}
.tox .tox-edit-area__iframe{
  background:${({ theme }) => theme.tinyMCEBackgroundColor};
  color:${({ theme }) => theme.tinyMCETextColor};
}

.security-chart-card{
  background:${({ theme }) => theme.uiSecurityChartCardBackground};

}
.calendar-checkbox{
  color:#000000 !important;
}
.ui.checkbox label:hover, .ui.checkbox+label:hover{
  color:${({ theme }) => theme.uiCheckBoxHoverColor};

}
.clndr-cell, .clndr-days{
  background:${({ theme }) => theme.uiSemanticDatePickerBackgroundColor};
}

.clndr-cell:hover{
  background:${({ theme }) => theme.uiSemanticDatePickerHoverColor};
}

.clndr-cell-selected{
  background:${({ theme }) => theme.uiSemanticDatePickerSelectedColor};
}


/********************************************************************************************************************************************/









/*****************************************************DG Report Styling**********************************************************/
.ui.card.card-dg-reports{
  margin-bottom 20px;
  margin-right:20px;
  font-size:14px;
  color:${({ theme }) => theme.uiCardDGReportsTextColor};
  background-color:${({ theme }) => theme.uiCardDGReportsBackground};
  border-left: 5px solid ${({ theme }) => theme.uiCardLeftBorder};
}

.dg-report-header-body{
  display:flex;
  justify-content:space-between;
}

.dg-executive-summary-body{
  padding-left:2rem;
}

.dg-report-card-heading{
  padding:1rem;
}
.dg-publish-date-container{
  display:flex;
  flex-direction:row;
}
/********************************************************************************************************************************************/









/***************************************************************Button styling****************************************************************/
.back-button{
  position:absolute;
  height:fit-content;
  top:0;
  right:0;
  padding:7rem;
}

.ui.button.delete-button{
  margin:1rem;
  background-color:${({ theme }) => theme.uiButtonDeleteBackgroundColor};
  color:${({ theme }) => theme.uiButtonDeleteTextColor};
}

.ui.button.view-button, .ui.button.email-button{
  background-color:${({ theme }) => theme.uiButtonViewEmailBackgroundColor};
  color:${({ theme }) => theme.uiButtonViewEmailTextColor};
}

.ui.button.edit-button{
  margin:1rem;
  background-color:${({ theme }) => theme.uiButtonEditBackgroundColor};
  color:${({ theme }) => theme.uiButtonEditTextColor}
}

.ui.button.table-button{
  background-color:${({ theme }) => theme.uiButtonTableBackgroundColor};
  color:${({ theme }) => theme.uiButtonTableTextColor};
}

.ui.button.details-back-button{
  margin-bottom:1rem;
}

.progress-step-button{
  display:none;
}

.ui.button.clipboard-button{
  margin:1rem;
}

.login-button-group{
  margin-top: 1.5rem !important;
}
/********************************************************************************************************************************************/










/***************************************************************Task Styling****************************************************************/
.task-template-names{
  padding:0.5rem;
}
/********************************************************************************************************************************************/












/***************************************************************Loading page styling****************************************************************/
.loading-page{
  background-color:${({ theme }) => theme.loadingPage};
  color:${({ theme }) => theme.loadingPageTextColor};
}

.loader-container{
  z-index:-1;
}
/***************************************************************************************************************************************************/






/***************************************************************Contact styling****************************************************************/
.contact-info{
  margin:1rem;
}
/**********************************************************************************************************************************************/









/*****************************************************MUI Datatable**********************************************************/

.level-column{
  background-color:${({ theme }) => theme.muiLevelColumn};
  border-right:1px solid #FFFFFF;
}

.MuiTableHead-root {
  z-index:-1 !important;
}

.mui-datatable{
  z-index:-1;
}

.MuiTableCell-root .MuiTableCell-footer .mui-custom-footer{
  border-right: 1px solid blue !important;

}
/****************************************************************************************************************************/













/*********************************************** CIP Evidence Styling **********************************************************/
.cip-evidence-container{
  margin:2rem !important;
}
.cip-evidence-image-counter{
  text-align:center;
}
/********************************************************************************************************************************/





/*********************************************** CIP Patch Tracker **********************************************************/
.log-history-events{
  border-bottom:1px solid #e5e5e5;
}

.log-history-header{
  border-top:0 !important;
  margin-top:10px !important;
  background:#ffffff !important;
}
.log-history-title{
  color:#ffffff !important;
  background:#1B1C1D !important;
}

.history-container{
  display:inline-block;
  cursor:pointer;
  textAlign:center;
}
.clickable-history-text{
  color:blue;
  transition:color 0.3s ease
}

.updated-line {
  font-weight: bold; 
}

.details-line {
  display: flex; 
  gap: 8px; /* Adds space between items */
}
.old-value {
  color: #555; /* Dim the old value to focus on the new value */
}
.new-value {
  color: red; /* Keep the new value highlighted */
  font-weight: bold; /* Emphasize the new value */
}
/********************************************************************************************************************************/






/*************************************************** Crowdstrike ****************************************************************/


.crowdstrike-clipboard-box{
  display:flex;
  border:1px solid #e5e5e5;
  padding:1rem;
  justify-content:space-between;
  align-items:center;
}

.crowdstrike-clipboard-header{

}

.crowdstrike-code-box{
  color:${({ theme }) => theme.crowdstrikeCodeBox};
}
.crowdstrike-clipboard-button{
  float:right;
}

/********************************************************************************************************************************/



.denied-page {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    height: 100vh !important;
}
.denied-segment {
    width: 100%; /* Make the segment fill the available width */
    max-width: 800px; /* You can adjust this max-width as needed */
    text-align: left;
    padding: 20px; /* Add some padding inside the segment */
}

.denied-header {
    color: #721c24;
    text-align: center;
    margin-top: 10px;
    white-space: nowrap; /* This ensures the text stays on one line */

}
.denied-error-message {
    color: #721c24;
    font-weight: bold;
    text-align: center;
}
.denied-support-message {
    color: #721c24;
    text-align: center;
}
.denied-support-link {
    color: #721c24;
    text-decoration: underline;
}
.denied-support-link:hover {
    color: #a71e28;
    text-decoration: none;
}

.notfound-page {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    height: 100vh !important;
}
.notfound-segment {
    max-width: 500px;
    text-align: left;
}
.notfound-header {
    color: #721c24;
    text-align: center;
    margin-top: 10px;
}
.notfound-error-message {
    color: #721c24;
    font-weight: bold;
    text-align: center;
}
.notfound-support-message {
    color: #721c24;
    text-align: center;
}
.notfound-support-link {
    color: #721c24;
    text-decoration: underline;
}
.notfound-support-link:hover {
    color: #a71e28;
    text-decoration: none;
}


/*********************************************** Gridknowledge Styling **********************************************************/

figure.align-left {float: left;}
figure.align-right {float: right;}

figure.image.align-center{
  display: table;
  margin-left:auto;
  margin-right:auto;
  border: 1px solid gray;
  background: #656565;
}

figcaption {margin: 6px 8px 6px 8px; text-align: center; font-size:14px; color:#fff;} 

.knowledgebase-customer-view{
  font-family:arial; 
  color:${({ theme }) => theme.knowledgebaseCustomerView};
  background-color:${({ theme }) => theme.knowledgebaseCustomerViewBackgroundColor};

}

.gridknowledge-summary{
  min-heightf:20px;
  padding:35px;
  font-size:initial;
  margin-top:1rem;
  margin-bottom:20px;
  background-color:#f5f5f5;
  border:1px solid #e3e3e3;
  border-radius:4px;
  color:#31708f;
}
.inline-buttons{
  display:flex;
}

.gridknowledge-form-summary{
  margin-bottom:2rem !important;
}

.tiny-table, .tiny-table tbody{
  border-collapse: collapse; 
  width: 100%;
  overflow-x:auto !important;
  table-layout: fixed;
}
.editor-container.editor-loading {
  position: relative;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

.gridknowledge-panes{
  height:60rem;
}

.article-container{
  margin:2rem !important;
}


/********************************************************************************************************************************/


/***************************************CISA Report*************************************************************/

.detection-timeline{
  overflow-x:auto;
}







/********************************************************************************************************************************/







/***************************************Internal Ticket Details Page*************************************************************/
@media screen and (min-width: 768px){
  .overflow-height{
    overflow-y:auto;
    height:90vh;
  }
}

.ticket-favorite-button-group{
  margin:0.3rem !important;
}
.ticket-details{
  display:flex;
  justify-content:space-around;
}
.canned-button-group{
  display:flex;
}
.ui.header.internal-ticket-details-header-container{
  display:flex !important;
  flex-direction:column;
  flex-wrap:nowrap;
  align-content:flex-start;
  justify-content:flex-end;
  align-items:center;
}
.ui.header .sub.header.internal-ticket-details-subheader{
  padding:0.5rem;
}


/* Page Context */
.pushable:not(body) {
  transform: none;
}

.pushable:not(body) > .ui.sidebar,
.pushable:not(body) > .fixed,
.pushable:not(body) > .pusher:after {
  position: fixed;
}
.ui.grid.ticket-details-container{
  padding: 3em;
}

.internal-note-checkbox, .internal-note-accordians {
  color:${({ theme }) => theme.internalNoteColor};
}

.external-note-checkbox, .external-note-accordians {
  color:${({ theme }) => theme.externalNoteColor};
}

.update-note-checkbox, .update-note-accordians, .ui.styled.accordion .accordion .title, .ui.styled.accordion .title {
  color:${({ theme }) => theme.updateNoteColor};
}


.notes-container{
  overflow-y: auto;
  max-height: 50rem;
}

.datetime-input-wrapper{
  display:flex !important;
}

.calendar-date-wrapper{
  display:flex;
  justify-content:space-between;
}



.ticket-notes-toggle{
  padding:inherit !important;
}
/********************************************************************************************************************************/















/***********************************************************Diagram Styling***************************************************************************************/

.dndflow {
  flex-direction: column;
  display: flex;
  height: 100%;
}

.dndflow aside {
  border-right: 1px solid #eee;
  padding: 15px 10px;
  font-size: 12px;
  background: #fcfcfc;
}

.dndflow aside > * {
  margin-bottom: 10px;
  cursor: grab;
}

.dndflow aside .description {
  margin-bottom: 10px;
}

.dndflow .reactflow-wrapper {
  flex-grow: 1;
  height: 100%;
}

@media screen and (min-width: 768px) {
  .dndflow {
    flex-direction: row;
  }

  .dndflow aside {
    width: 20%;
    max-width: 180px;
  }
}

.export {
  position: absolute;
  left: 12px;
  top: 12px;
  min-width: 120px;
  background-color: #F5F5F5;
  z-index: 5;
  border: 1px solid #CACACA;
  padding: 12px;
  border-radius: 5px;
}


.diagrams-input-node-container, .diagrams-output-node-container, .databaseNode-diagrams-container, .react-flow__table-node {
  padding: 10px;
  border-radius: 3px;
  width: 150px;
  font-size: 12px;
  color: #222;
  text-align: center;
  border-width: 1px;
  border-style: solid;
}
.diagrams-input-node-container, .diagrams-output-node-container, .databaseNode-diagrams-container, .react-flow__table-node.selectable {
  &:hover {
    box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.08);
  }
}

.react-flow__table-node {
  background: #fff;
  border-color: #f3851d;

  &.selected,
  &.selected:hover {
    box-shadow: 0 0 0 0.5px #ff0072;
  }
}
.diagrams-input-node-container{
  border-color: #0041d0;
  width:100%;

  &.selected,
  &.selected:hover {
    box-shadow: 0 0 0 0.5px #ff0072;
  }
}

.diagrams-output-node-container{
  background: #fff;
  width:100%;

  &.selected,
  &.selected:hover {
    box-shadow: 0 0 0 0.5px #ff0072;
  }
}

.ui.form.ui.top.attached.table.react-flow__table-node{
  border-color: #f3851d;
}

.inputNode-diagrams, .output-diagrams{
  border-radius: 5px;
  background: transparent;
  border
  height: 94%;
  width: 98%;
  top:0px;
}

.tableOutput-node{
  border-radius: 5px;
  background: transparent;
  height: 100%;
  width: 100%;
  top:inherit;
}

.databaseNode-diagrams-container{
  background:lightskyblue;
  width:fit-content;
  height:fit-content;
  border-radius:100%/30%;
  display:flex;
  flex-direction:column;
  flex-wrap:center;
  justify-content:center;
}

.databaseNode-diagrams-textarea{
  background: transparent;
  padding: 1rem;
  margin: 1.5rem;
  border: none;
}

.react-flow__handle{
  border:none
}

.ui.form.node-details-menu{
  position:absolute;
  z-index:13;
  right:0px;
  border-right: 1px solid #eee;
  padding: 15px 10px 15px 10px;
  font-size: 12px;
  background:#fcfcfc;
  width:24.25rem;
}

.diagrams-diamond-node-container{
  background: white;
  border-color:black;
  border: 1px solid #222;
  border-radius: 2px;
  transform: translate(-50%, -50%) rotate(45deg);
  left: 50%;
  top:50%;
}

.diagrams-diamond-label{
  display:flex;
  justify-content: center;
  align-items: center;
  height:100%;
  transform:rotate(-45deg);
}

.diagrams-circle-node-container{
  padding:14px;
  border: 1px solid #222;
  border-radius:14.375rem;
  display:flex;
  justify-content:center;
  align-items:center
}
.diagram-container{
  height:50rem;
}
/*************************************************************************************************************************************************************************/


/*************************************************Software Tracking*************************************************************************/


.mitigation-plan-form{
  padding:1rem;
}
.search-container-debounced{
  margin:1rem;
}
/*************************************************************************************************************************************************************************/

/*************************************************Google Maps Page *************************************************************************/
.google-maps-ticket-list{
  overflow-y:auto;
  height:42vh;
}

.google-circle {
  background-color: #d83b01;
  border-radius: 50%;
  color: #fff;
  height: 2.5em;
  position: relative;
  width: 2.5em;
  border: 1px solid transparent;
}

.google-circleText {
  text-align: center;
  height: 50%;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
}

.google-hover {
  background-color: #0078d4;
}


/******************************************************************************************************************************************/


/*************************************************Portal Components *************************************************************************/
.delete-modal-component{
  padding-top:1rem;
}
.delete-modal-component .replacement-modal-component{
  padding-bottom:1rem !important;
}


/******************************************************************************************************************************************/


/*********************************************** Small Devices, Tablets **********************************************************/
@media all and (max-width: 767px) and (min-width : 270px) {
    img {
      max-width:100%;
      max-height:100%;
      height: auto;
    }
    .tiny-table thead {
      border: none;
      clip: rect(0 0 0 0);
      height: 2rem;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      position: absolute;
      width: 1px;
    }
    
    .tiny-table tr {
      margin-bottom: .625em;
    }
    
    .tiny-table td {
      font-size: .8em;
      text-align: center;
    }
    .sidebar-article{
      margin-left:0px !important;
    }
    .ui.visible.left.overlay.sidebar{
      width:15rem;
    }
    .ui.container{
      margin-top: 3em;
    }
    .ui.attached.tabular.menu{
      display:flex !important;
      flex-direction:column !important;
    }
    .ui.tabular.menu .item{
      border-color:#d4d4d5 !important;
    }
    .header-container{
      display:flex;
      flex-direction:column !important;
    }
    .ui.cards{
      margin:0 !important;
    }
    .ui.search.dropdown>input.search{

    }
    .nri-container{
      padding:0rem !important;
      padding-top:3rem !important;
    }
    .fc .fc-toolbar{
      display:flex;
      flex-direction: column !important;
    }
    .fc .fc-scroller-liquid{
      overflow: auto !important;
    }

    .ticket-details-container{
      padding:0rem !important;
      padding-top:3rem !important;
    }

}

`;

export default GlobalStyle;